<template>
    <b-navbar   type="light" class="navbar-light theme-nav fixed-top" toggleable="lg" fixed="top"  v-b-scrollspy:nav-scroller>
        <div class="container">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand class="navbar-brand" :to="{name:'Main_page'}" ><img :src='"../assets/images/logo.png"' alt="logo"></b-navbar-brand>
            <b-collapse class="default-nav"  is-nav id="nav_collapse">
                <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
                    <b-nav-item href="#home">Home</b-nav-item>
                    <b-nav-item href="#about">about</b-nav-item>
                    <b-nav-item href="#feature">feature</b-nav-item>
                    <b-nav-item href="#screenshot">screenshot</b-nav-item>
                    <b-nav-item href="#team">team</b-nav-item>

                    <b-nav-item-dropdown right-alignment text="blog" class="nav-link">
                        <b-dropdown-item class="nav-link"   :href='"#blog"'>Blog</b-dropdown-item>
                        <b-dropdown-item class="nav-link"  :to="{name:'blog_list'}" >Blog list</b-dropdown-item>
                        <!-- <b-dropdown-item class="nav-link"  :to="{name:'Blog_details'}" >Blog details</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_leftside'}">Left sidebar</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Blog_rightside'}">Right sidebar</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'BlogLeftSidebar'}">Details left sidebar</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'BlogrightSidebar'}" >Details right sidebar</b-dropdown-item> -->
                    </b-nav-item-dropdown>

                    <b-nav-item href="#price">price</b-nav-item>
                    <b-nav-item href="#contact">contact us</b-nav-item>

                    <b-nav-item-dropdown right-alignment href="#Other_page" text="Examples" class="nav-link ">
                        <!-- <b-dropdown-item class="nav-link"  :to="{name:'Signin'}" :href='"sign-in"'>sign in</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Signup'}" :href='"/sign-up"' >sign up</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'ForgetPassword'}" :href='"/forget-Password"' >Forget Password</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Thankyou'}" :href='"/thank-you"' >Thank you</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Review'}" :href='"/review"' >Review</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'pagenotfound'}" :href='"/404"' >404</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'Faq'}" :href='"/faq"' >FAQ</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'download'}" :href='"/download"' >Download</b-dropdown-item>
            <b-dropdown-item class="nav-link"  :to="{name:'coming_soon'}" :href='"/coming-soon"' >coming soon</b-dropdown-item> -->
                        <b-dropdown-item class="nav-link"  href="https://demos.xtremecontrols.co.uk/hospitality" >Hospitality Demo</b-dropdown-item>
                        <b-dropdown-item class="nav-link"  href="https://demos.xtremecontrols.co.uk/carpark" >Car Park Demo</b-dropdown-item>
                        <b-dropdown-item class="nav-link"  href="https://demos.xtremecontrols.co.uk/locker" >Locker Demo</b-dropdown-item>
                        <b-dropdown-item class="nav-link"  href="http://xtremecontrols.co.uk/care/" >XRMS Leaflet</b-dropdown-item>
                        <b-dropdown-item class="nav-link"  href="http://xtremecontrols.co.uk/hospitality/" >Hospitality Leaflet</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
</template>
<script>
export default {
    name: "Navbar",
    beforeCreate: function () {
        document.body.className = ""
    }
}
</script>



// WEBPACK FOOTER //
// src/components/navbar_blog.vue